import { axios } from '@/utils/axios';

type DownloadTicketResponse = {
  success: boolean;
  data: { downloadUrl: string; expiresAt: string };
};

const ticketEndpointPattern = /^\/api\/(?:storage-files\/\d+|public\/share\/[A-Za-z0-9]+\/storage-files\/\d+)\/download-ticket$/;
const downloadUrlPattern = /^\/api\/storage-downloads\/[A-Za-z0-9_-]{43}$/;

const openDownloadWindow = () => {
  const popup = window.open('', '_blank');
  if (popup) {
    popup.opener = null;
    const policy = popup.document.createElement('meta');
    policy.name = 'referrer';
    policy.content = 'no-referrer';
    popup.document.head.appendChild(policy);
  }
  return popup;
};

const requireDownloadUrl = (url: string) => {
  if (!downloadUrlPattern.test(url)) throw new Error('Invalid storage download URL.');
  return url;
};

export const openStorageDownload = async (
  ticketEndpoint: string,
  options?: { shareSessionToken?: string }
) => {
  const popup = openDownloadWindow();
  try {
    if (!ticketEndpointPattern.test(ticketEndpoint)) throw new Error('Invalid storage ticket endpoint.');
    const response = await axios.post<DownloadTicketResponse>(ticketEndpoint, undefined, {
      headers: options?.shareSessionToken ? { 'X-Share-Session': options.shareSessionToken } : undefined,
    });
    const downloadUrl = requireDownloadUrl(response.data.data.downloadUrl);
    if (popup) popup.location.href = downloadUrl;
    else window.location.assign(downloadUrl);
  } catch (error) {
    popup?.close();
    throw error;
  }
};

export const openAnonymousCreditReportDownload = async (
  ticketEndpoint: string,
  credentials: { anonymousEmail: string; token: string }
) => {
  const popup = openDownloadWindow();
  try {
    const match = ticketEndpoint.match(/^\/api\/storage-files\/(\d+)\/download-ticket$/);
    if (!match) throw new Error('Invalid credit report download endpoint.');
    const response = await axios.post<DownloadTicketResponse>(
      `/api/creditReport/getReportByAnonymousEmail/${match[1]}/download-ticket`,
      credentials
    );
    const downloadUrl = requireDownloadUrl(response.data.data.downloadUrl);
    if (popup) popup.location.href = downloadUrl;
    else window.location.assign(downloadUrl);
  } catch (error) {
    popup?.close();
    throw error;
  }
};
